import React, {
  useState,
  useMemo,
  Fragment,
  memo,
  useEffect,
  useCallback,
  useContext,
} from "react";
import Countdown from "react-countdown";
import _ from "lodash";
import {
  useTable,
  usePagination,
  useFilters,
  useGlobalFilter,
  useSortBy,
  useRowSelect,
} from "react-table";
import { useSelector } from "react-redux";
import classNames from "classnames";
import { format } from "date-fns";
import Swal from "sweetalert2";
import { faAngleUp, faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dialog } from "@headlessui/react";

import { Auth, Storage } from "aws-amplify";
import AWS from "aws-sdk";
import API from "../api/api.main";

const Row = ({ row, i, value, getData, where, type }) => {
  const { user } = useSelector((state) => state.initializeApp);

  const [error, setError] = useState(false);
  const [form, setForm] = useState({
    ...value,
  });
  const [showModal, setShowModal] = useState(false);

  const onSubmit = async () => {
    try {
      const result = await Swal.fire({
        title: "คุณยืนยันที่จะอนุมัตินี้หรือไม่ ?",
        showCancelButton: true,
        confirmButtonText: `บันทึก`,
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
        showLoaderOnDeny: false,
        preConfirm: async () => {
          if (
            !form.period_12 ||
            !form.period_24 ||
            !form.period_36 ||
            !form.period_48 ||
            !form.period_60 ||
            !form.period_12_eff ||
            !form.period_24_eff ||
            !form.period_36_eff ||
            !form.period_48_eff ||
            !form.period_60_eff
          ) {
            setError(true);
            return {
              error: true,
            };
          }

          if (
            Number(form?.period_12_eff) < 8 ||
            Number(form?.period_24_eff) < 11.6 ||
            Number(form?.period_36_eff) < 12.8 ||
            Number(form?.period_48_eff) < 13.2 ||
            Number(form?.period_60_eff) < 13.6
          ) {
            setError(true);
            return {
              error: false,
              error2: true,
            };
          }

          await API.post("MoneyHubAdmin", `/leasing/interestTF`, {
            body: {
              year: form?.name,
              ...form,
            },
            headers: {
              Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`,
            },
          });
        },
      });
      if (result.value?.error) {
        return await Swal.fire({
          title: "WARNING",
          text: `โปรดกรอกข้อมูลอัตราดอกเบี้ย`,
          icon: "warning",
          confirmButtonText: "ยืนยัน",
        });
      }
      if (result.value?.error2) {
        return await Swal.fire({
          title: "WARNING",
          text: `โปรดกรอกข้อมูลอัตราดอกเบี้ยให้ถูกต้อง`,
          icon: "warning",
          confirmButtonText: "ยืนยัน",
        });
      }
      if (!result.isConfirmed) return;
      await Swal.fire({
        title: "SUCCESS",
        text: "อัพเดตข้อมูลสำเร็จ",
        icon: "success",
        confirmButtonText: "ยืนยัน",
      });
      await getData(where);
    } catch (error) {
      console.log("Error", error);
      await Swal.fire({
        title: "ERROR",
        text: "Something went wrong",
        icon: "error",
        confirmButtonText: "ยืนยัน",
      });
    }
  };

  return (
    <Fragment>
      <tr
        {...row.getRowProps()}
        onClick={() => setShowModal(true)}
        className={classNames(
          "cursor-pointer hover:bg-blueGray-200 transition-all duration-300",
          {
            "bg-white": i % 2 === 0,
            "bg-gray-100": i % 2 !== 0,
          }
        )}
      >
        {row.cells.map((cell, index) => {
          return (
            <td
              className={"p-4 text-gray-700 text-sm text-center"}
              {...cell.getCellProps()}
            >
              {cell.render("Cell")}
            </td>
          );
        })}
      </tr>
      <Dialog
        open={showModal}
        className="fixed z-10 inset-0 overflow-y-auto"
        onClose={() => setShowModal(false)}
      >
        <div className="flex items-center justify-center min-h-screen">
          <div className="bg-white border border-gray-300 rounded max-w-sm mx-auto p-4 z-20">
            <Dialog.Title className="font-black text-lg">
              {value?.name}
            </Dialog.Title>
            <Dialog.Description className="my-4">
              <div className="">
                {[
                  // { label: "ปีรถ", name: "year", type: "text" },
                  {
                    label: "งวด 12",
                    name: "period_12",
                    name2: "period_12_eff",
                    validate: 8,
                  },
                  {
                    label: "งวด 24",
                    name: "period_24",
                    name2: "period_24_eff",
                    validate: 11.6,
                  },
                  {
                    label: "งวด 36",
                    name: "period_36",
                    name2: "period_36_eff",
                    validate: 12.8,
                  },
                  {
                    label: "งวด 48",
                    name: "period_48",
                    name2: "period_48_eff",
                    validate: 13.2,
                  },
                  {
                    label: "งวด 60",
                    name: "period_60",
                    name2: "period_60_eff",
                    validate: 13.6,
                  },
                ].map((item, index) => {
                  if (item.label === "ปีรถ") {
                    return (
                      <div key={index} className="mb-2">
                        {" "}
                        <div>{item?.label}</div>
                        <div className="ml-1 flex flex-col mb-1">
                          <div className="flex items-center space-x-1">
                            <input
                              className="border border-gray-300 focus:outline-none px-3 py-2 rounded"
                              type={item?.type ? item?.type : "number"}
                              name={item.name}
                              value={form[item?.name]}
                              onChange={(e) =>
                                setForm({
                                  ...form,
                                  [item?.name]: e.target.value,
                                })
                              }
                            />
                            <span className="text-red-400 mx-2">
                              {error && item?.name === "year" && "*"}
                            </span>
                          </div>
                        </div>
                      </div>
                    );
                  }

                  return (
                    <div key={index} className="mb-2">
                      {" "}
                      <div>{item?.label}</div>
                      <div className="ml-1 flex flex-col mb-1">
                        <div className="">Flat Rate</div>
                        <div className="flex flex-col space-x-1">
                          <input
                            className="border border-gray-300 focus:outline-none px-3 py-2 rounded"
                            type={item?.type ? item?.type : "number"}
                            name={item.name}
                            value={form[item?.name]}
                            onChange={(e) =>
                              setForm({
                                ...form,
                                [item?.name]: e.target.value,
                              })
                            }
                          />
                          <span className="text-red-400 mx-2">
                            {error && !form[item.name] && "โปรดใส่รายละเอียด"}
                          </span>
                        </div>
                      </div>
                      <div className="ml-1 flex flex-col">
                        <div className="">
                          Effective Interest Rate (min = {item?.validate})
                        </div>
                        <div className="flex flex-col space-x-1">
                          <input
                            className="border border-gray-300 focus:outline-none px-3 py-2 rounded"
                            type={item?.type ? item?.type : "number"}
                            name={item.name2}
                            value={form[item?.name2]}
                            onChange={(e) =>
                              setForm({
                                ...form,
                                [item?.name2]: e.target.value,
                              })
                            }
                          />
                          <span className="text-red-400 mx-2">
                            {!form[item?.name2] && "โปรดกรอกข้อมูล"}
                          </span>
                          <span className="text-red-400 mx-2">
                            {form[item?.name2] &&
                              form[item?.name2] < item?.validate &&
                              `ขั้นต่ำ ${item?.validate}`}
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </Dialog.Description>
            <button
              className="p-2 bg-blue-500 text-white w-20 mr-4 rounded"
              onClick={onSubmit}
            >
              ตกลง
            </button>
            <button
              className="p-2 text-blue-500 border border-blue-500 w-20 rounded"
              onClick={() => setShowModal(false)}
            >
              ยกเลิก
            </button>
          </div>
        </div>
      </Dialog>
    </Fragment>
  );
};

function InterestTFTable({ data, getData, where, type }) {
  const { user } = useSelector((state) => state.initializeApp);

  const columns = useMemo(() => {
    return [
      {
        Header: "ปีรถ",
        accessor: "name",
      },
      {
        Header: "งวด 12",
        accessor: "period_12",
        Cell: ({ row }) => {
          return (
            <div className="flex text-center items-center justify-center">
              <div className="mr-1">{row.original?.period_12}</div>
              <div>/</div>
              <div className="ml-1">{row.original?.period_12_eff}</div>
            </div>
          );
        },
      },
      {
        Header: "งวด 24",
        accessor: "period_24",
        Cell: ({ row }) => {
          return (
            <div className="flex text-center items-center justify-center">
              <div className="mr-1">{row.original?.period_24}</div>
              <div>/</div>
              <div className="ml-1">{row.original?.period_24_eff}</div>
            </div>
          );
        },
      },
      {
        Header: "งวด 36",
        accessor: "period_36",
        Cell: ({ row }) => {
          return (
            <div className="flex text-center items-center justify-center">
              <div className="mr-1">{row.original?.period_36}</div>
              <div>/</div>
              <div className="ml-1">{row.original?.period_36_eff}</div>
            </div>
          );
        },
      },
      {
        Header: "งวด 48",
        accessor: "period_48",
        Cell: ({ row }) => {
          return (
            <div className="flex text-center items-center justify-center">
              <div className="mr-1">{row.original?.period_48}</div>
              <div>/</div>
              <div className="ml-1">{row.original?.period_48_eff}</div>
            </div>
          );
        },
      },
      {
        Header: "งวด 60",
        accessor: "period_60",
        Cell: ({ row }) => {
          return (
            <div className="flex text-center items-center justify-center">
              <div className="mr-1">{row.original?.period_60}</div>
              <div>/</div>
              <div className="ml-1">{row.original?.period_60_eff}</div>
            </div>
          );
        },
      },
    ];
  }, []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    selectedFlatRows,
  } = useTable({
    columns,
    data,
  });

  return (
    <div className="mx-4 mb-2">
      <div className="bg-white rounded border border-gray-300 w-full overflow-x-auto ">
        <table {...getTableProps()} className="w-full whitespace-no-wrap">
          <thead className=" text-sm font-semibold tracking-wide text-gray-500  border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800">
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, i) => (
                  <th
                    {...column.getHeaderProps()}
                    className={classNames("px-4 py-3 text-center", {
                      "rounded-tl": i === 0,
                      "rounded-tr": i === headerGroup.headers.length - 1,
                    })}
                  >
                    {column.render("Header")}
                    <span>
                      {" "}
                      {column.isSorted ? (
                        column.isSortedDesc ? (
                          <FontAwesomeIcon icon={faAngleDown} />
                        ) : (
                          <FontAwesomeIcon icon={faAngleUp} />
                        )
                      ) : (
                        ""
                      )}
                    </span>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody
            className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800 text-gray-700 dark:text-gray-400"
            {...getTableBodyProps()}
          >
            {rows.map((row, i) => {
              prepareRow(row);
              return (
                <Row
                  type={type}
                  where={where}
                  key={row.getRowProps().key}
                  i={i}
                  row={row}
                  value={data[i]}
                  getData={getData}
                />
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default InterestTFTable;
